module.exports = __webpack_public_path__ + "static/media/batchIcon.069c031f.svg";